import axios from "axios";
import { ObjectID } from "bson";
import EzS3Image from "./vue-ez-s3-image.vue";

const s3Image = {
  install(Vue, options = {}) {
    Vue.component("EzS3Image", EzS3Image);

    let s3Image = {
      $vm: null,
      init(vm) {
        this.$vm = vm;
      },
      API_URL: options.apiUrl || "http://localhost:3001/v1",
      FILE_SIZE_MAX: options.fileSizeMax || 2 * 1024 * 1024,
      FILE_TYPES: options.fileTypes || ["image/png", "image/gif", "image/jpeg"],
      ORIGIN: options.origin || "Unknown",
      async uploadImage(payload) {
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open("PUT", payload.signedRequest);
          xhr.setRequestHeader("Content-Type", payload.file.type);
          xhr.onreadystatechange = async () => {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                resolve(xhr.response);
              } else {
                reject(xhr.response);
              }
            }
          };
          xhr.send(payload.file);
        });
      },
      s3Key(userId, ext) {
        let imageId = new ObjectID().toString();
        return `${userId}/${imageId}.${ext}`;
      },
      async createImage(userId, payload, name) {
        try {
          if (!payload.file) return payload;
          // GET s3 SIGNED PUT URL
          let key = this.s3Key(userId, payload.file.type.split("/")[1]);

          let signedUrlPut = await axios.post(`${this.API_URL}/s3/signedUrl`, {
            key: key,
            type: payload.file.type,
            size: payload.file.size
          });

          // UPLOAD IMAGE
          await this.uploadImage({
            signedRequest: signedUrlPut.data.signedRequest,
            file: payload.file
          });

          // CREATE IMAGE RECORD
          let item = await axios.post(`${this.API_URL}/images`, {
            key: key,
            size: payload.file.size,
            type: payload.file.type,
            url: signedUrlPut.data.url,
            origin: this.ORIGIN,
            description: name
          });

          return item;
        } catch (err) {
          console.error(err.response.data);
          this.errors = Object.assign({}, this.errors, err.response.data);
        }
      },
      async deleteImage(id) {
        if (!id) return true;
        try {
          await axios.delete(`${this.API_URL}/images/${id}`);
          return true;
        } catch (err) {
          console.error(err.response.data);
          return false;
        }
      }
    };

    Vue.prototype.$s3Image = s3Image;
  }
};

export default s3Image;
